module.exports = __webpack_public_path__ + "static/media/ikona-facebook.01c25cb2.svg";